// CLISUP-181 part (c), browser half. Coolify builds web/ alone, so this file
// does not import the Deno copy in supabase/functions/_shared/questionnaire-due.ts.
// Both compute 23:59:59 Europe/Copenhagen for a chosen YYYY-MM-DD.
//
// Drop this file and the SendFormsAssignmentModal call to restore "start of
// the chosen day". The mail date formatter does not depend on it.

import { CLINIC_TIMEZONE, zonedInstant } from '@/lib/reporting/timezone';

/** 23:59:59 Europe/Copenhagen on the chosen calendar day (`YYYY-MM-DD`). */
export function endOfChosenClinicDay(isoDate: string, timeZone = CLINIC_TIMEZONE): Date {
  const [year, month, day] = isoDate.split('-').map(Number);
  if (!year || !month || !day) {
    throw new Error(`invalid clinic date ${isoDate}`);
  }
  return zonedInstant(year, month, day, 23, 59, 59, 0, timeZone);
}
